import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor, HmacInterceptor } from './interceptors';
import { AuthenticationService, KindeClientService } from './services';
import { KindeClient } from '@kinde-oss/kinde-auth-pkce-js';
import { environment } from '../../environments/environment';


const kindeInitializer: (kindeClientService: KindeClientService, auth: AuthenticationService) =>
    () => Promise<KindeClient> = (kindeClientService: KindeClientService, auth: AuthenticationService) => (): Promise<KindeClient> => {
    return kindeClientService.initiate({
        ...environment.kinde,
        on_error_callback: () => {
            auth.logout();
        },
        on_redirect_callback: (user, appState) => {
            if (appState?.redirectTo) {
                window.location.href = appState?.redirectTo as string;
            }
        }
    });
}

@NgModule({
    imports: [
        CommonModule
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HmacInterceptor,
            multi: true
        },
        provideAppInitializer(() => {
        const initializerFn = (kindeInitializer)(inject(KindeClientService), inject(AuthenticationService));
        return initializerFn();
      }),
    ],
})
export class CoreModule { }
